import { render, staticRenderFns } from "./UserDropdown.vue?vue&type=template&id=728d3bac&scoped=true"
import script from "./UserDropdown.vue?vue&type=script&lang=js"
export * from "./UserDropdown.vue?vue&type=script&lang=js"
import style0 from "./UserDropdown.vue?vue&type=style&index=0&id=728d3bac&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "728d3bac",
  null
  
)

export default component.exports